import API from './API';
import { store } from '../redux';

export const getIdentityProviders = () => {
  const testData = store.getState().devTools;

  if (
    testData &&
    testData.mockedSocialURLs &&
    testData.mockedSocialURLs.length
  ) {
    return new Promise(resolve =>
      resolve({ data: { providers: testData.mockedSocialURLs } }),
    );
  }

  return API.SignupService().getIdentityProviders();
};
